<template>
  <el-table-column
    :prop="prop"
    :label="label"
    :width="width"
    :min-width="minWidth"
    :align="align"
    :fixed="fixed"
    :class-name="noFocus?'no-focus':''"
  >
    <template slot-scope="{row,$index}">
      <slot v-bind="{row,$index}"></slot>
    </template>
  </el-table-column>
</template>
<script>
export default {
  props: {
    prop: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: null,
    },
    minWidth: {
      type: String,
      default: null,
    },
    align: {
      type: String,
      default: null,
    },
    fixed: {
      type: String,
      default: null,
    },
    noFocus: {
      type: Boolean,
      default: false,
    },
  },
};
</script>